import BaseHeading from "../../../../baseComponents/baseHeading.js";
import BaseButton from "../../../../baseComponents/baseButton.js";
import { Container, Row, Column, Col } from "reactstrap";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../../../store/slices/loginSlice.js";
import { asyncActions as successAsyncActions } from "../../../../store/slices/successSlice.js";
import useBootstrap from "../../../../customHooks/useBootstrap";
import useColors from "../../../../customHooks/useColors";
import WithConfirm from "../../../../HOC/WithConfirm.js";
import BaseParagraph from "../../../../baseComponents/baseParagraph.js";

const DeactivateAccountComponent = ({ openConfirm }) => {
  ////////////////////////////////////////////////////////////////DISPATCHER
  const dispatch = useDispatch();

  ////////////////////////////////////////////////////////////////REDUX STATES
  const [currentColors] = useColors();

  ////////////////////////////////////////////////////////////////CONSTANTS

  const { trashold4, trashold8 } = useBootstrap();

  ////////////////////////////////////////////////////////////////LOCAL STATES

  const [errorMsg, setErrorMsg] = useState("");

  ///////////////////////////////////////////////////////////////////EFFECTS
  /*
    clear errors on mount
  */
  useEffect(() => {
    clearUserError();
  }, []);

  ////////////////////////////////////////////////////////////////HANDLING FUNCTIONS

  ////////////////////////////////////////////////////////////////METHODS


  const clearUserError = () => {
    setErrorMsg("");
  };

  const deactivateAccount = async () => {
    
    const { confirmPressed } = await openConfirm({
      title: "deactivateAccount",
      text: "areYouSureUwantToDeactivate",
      isContinueInErrorColor: true,
    });
    
  
    if (confirmPressed === true) {
      const response = await dispatch(loginAsyncActions.deactivateAccount({setErrorMsg: setErrorMsg}));
   

      
    } 
  };

  ////////////////////////////////////////////////////////////////STYLE
  const styles = {
    mainContainer: {
      backgroundColor: currentColors.septenary,
      padding: "1em",
      display: "flex",
      flexDirection: "column",
      gap: "1em",
      width: "100%",
    },
  };

  return (
    <Container className="p-0" style={{ marginTop: "1em" }}>
      <Row className="g-0">
        <Col {...trashold8}>
          <div style={styles.mainContainer}>
            <BaseHeading h3 bold>
              deactivateAccount
            </BaseHeading>
            <BaseParagraph>deactivationDescription</BaseParagraph>
            <Row>
              <Col {...trashold4} />
              <Col {...trashold4} />
              <Col {...trashold4}>
                <BaseButton
                  style={{
                    backgroundColor: currentColors.octonary,
                  }}
                  error={errorMsg}
                  onClick={deactivateAccount}
                >
                  deactivateAccount
                </BaseButton>
              </Col>
            </Row>
          </div>
        </Col>
        <Col {...trashold4}></Col>
      </Row>
    </Container>
  );
};

export default WithConfirm(DeactivateAccountComponent);
